function iWishPost(e,t){method="post";var n=document.createElement("form");n.setAttribute("method",method);n.setAttribute("action",e);for(var r in t){if(t.hasOwnProperty(r)){var i=document.createElement("input");i.setAttribute("type","hidden");i.setAttribute("name",r);i.setAttribute("value",t[r]);n.appendChild(i)}}document.head.appendChild(n);n.submit()}
if(iwish_template != 'customers/login' && iwish_template != 'customers/register'){if(typeof(Storage) !== "undefined"){
    if(sessionStorage.iWishRedirect=='view')
    {
      sessionStorage.iWishRedirect='';iWishPost('/apps/iwish',{cust: iwish_cid});
    }
    if(sessionStorage.iWishRedirect=='post')
    {
      sessionStorage.iWishRedirect='';iWishPost('/apps/iwish',{cust: iwish_cid,pid:sessionStorage.iWishProduct,vid:sessionStorage.iWishVarient});
}}}